import { defineStore } from 'pinia';
import { API_URL, authFetch } from '../api';

export const useSavingsStore = defineStore('savings', {
  state: () => ({
    projections: {},
  }),
  actions: {
    async calculateProjection(account, years = 20, monthlyContribution = 0) {
      try {
        const startBalance = account.last_snapshot?.balance || 0;
        
        const projectionData = {
          initial_amount: startBalance,
          monthly_contribution: monthlyContribution,
          interest_rate: account.interest_rate || 0,
          years: years,
          compound_frequency: 'monthly'
        };

        const response = await authFetch(`${API_URL}/projections/savings`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(projectionData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        // Store API response directly
        this.projections[account.id] = {
          dates: data.dates,
          balances: data.balances,
          interest_earned: data.interest_earned
        };
        
        return this.projections[account.id];
      } catch (error) {
        console.error('Error calculating projection:', error);
        throw error;
      }
    }
  }
});